import React from "react";
import { useTranslation } from "react-i18next";

import { legendItemStyle, legendStyle } from "./style";

export const highWindSevereITALegendPerLevel = (t, level) => {
  return [
    `${t("levels.noData")} : (pw < 0)`,
    `${t("levels.low")} : (0 ≤ pw < 0.3)`,
    `${t("levels.moderate")} : (0.3 ≤ pw < 0.6)`,
    `${t("levels.significant")} : (0.6 ≤ pw < 0.9)`,
    `${t("levels.high")} : (pw ≥ 0.9)`,
  ][level];
};

export const highWindSevereITALegendLevels = () => {
  return [0, 0.3, 0.6, 0.9, 1.1];
  // 4 numerical intervals for normal legend (1,2,3,4)
  // Other values are considered as "no data"
  // The aproximate mathematical model can give up to 1.063 probability indication.
};

const HighWindSevereITALegend = () => {
  const { t } = useTranslation();

  return (
    <div style={legendStyle}>
      <div>
        <b>
          {t("riskAssessment.highWind")} (ITA) - {t("riskAssessment.severe")}
        </b>
      </div>
      <div>
        <span style={legendItemStyle("#fff5f0")}></span>
        {highWindSevereITALegendPerLevel(t, 1)}
      </div>
      <div>
        <span style={legendItemStyle("#fca486")}></span>
        {highWindSevereITALegendPerLevel(t, 2)}
      </div>
      <div>
        <span style={legendItemStyle("#ea372a")}></span>
        {highWindSevereITALegendPerLevel(t, 3)}
      </div>
      <div>
        <span style={legendItemStyle("#67000d")}></span>
        {highWindSevereITALegendPerLevel(t, 4)}
      </div>
      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "x-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          pw = {t("legend.windAnnualProbability")} (&gt; 25m/s)
        </span>
      </div>
      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          © CyStellar, {t("legend.dataFromRAIN")}
        </span>
      </div>
    </div>
  );
};

export default HighWindSevereITALegend;
